import { Box,  Card, CardContent, CardHeader, Stack, Typography } from "@mui/material";
import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import FormCheckbox from "../forms/form-checkbox/FormCheckbox";
import { useFormContext  } from "react-hook-form";
import { RecipientTypeEnum } from "../../common/enums/RecipientTypeEnum";
import { Email, PersonOff, Phone, SmsOutlined } from "@mui/icons-material";
import ActionMenu from "../action-menu/ActionMenu";
import { ActionMenuItem } from "../action-menu/ActionMenuItem";
import { FormRecipientItem } from "./FormRecipientList";
import { FormRecipientActions, IFormRecipient, IFormUserRecipient, RecipientsFormType } from "./FormRecipientListUtils";

export type FormRecipientListItemProps = {
    item: FormRecipientItem,
    showSelected: boolean;
    hideActions?: boolean;
    recipientType: RecipientTypeEnum;
    allowVoiceAlarm: boolean;
    onExecuteAction: (action: FormRecipientActions, payload: IFormUserRecipient) => void;
    onSelected?: (value: boolean) => void;
}

export function FormRecipientListItem({
    item,
    showSelected,
    hideActions,
    recipientType,
    allowVoiceAlarm,
    onExecuteAction,
    onSelected
}: FormRecipientListItemProps) {

    const { t } = useTranslation();


    const actionItems: ActionMenuItem[] = [{
            label: t("actions.addRecipient"),
            onClick: () => {
                onExecuteAction(FormRecipientActions.Add, item)
            }
        }, {
            label: t("actions.editRecipient"),
            onClick: () => {
                onExecuteAction(FormRecipientActions.Edit, item)
            }
        }
    ];


    const {
        //getValues,
        watch,
        //trigger,
        //control,
        //getValues,
        //trigger,
        //reset,
        //setValue,
        //resetField
    } = useFormContext<RecipientsFormType>();    
    
    const [userRecipients] = watch(['userRecipients']);


    // we need the 'real' index of the item
    const index = userRecipients.findIndex(o => o.userID === item.userID);

    const filteredRecipients = item.recipients
                            .filter(o => o.selected || !showSelected)
                            .filter(o => o.recipientType === recipientType || recipientType === RecipientTypeEnum.Invalid /*Invalid=All*/)
                            .filter(o => o.recipientType !== RecipientTypeEnum.Voice || allowVoiceAlarm);
                            

    function onRecipientChanged(value: boolean) {

        onSelected && onSelected(value);
        // if (value && alarmSchemes.find(o => o.selected)) {

        //     alarmSchemes.forEach((o, ndx) => {
        //         setValue(`alarmSchemes.${ndx}.selected`, false, {shouldDirty: true});
        //     })
        // }
    }
                        
    function getTitle(): ReactNode {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flex: '1 1 auto'
                }}>
                <Typography variant="body1">
                    {item.userName}
                </Typography>
                {
                    item.disabled && 
                    <PersonOff sx={{
                        marginLeft: 1
                    }}
                    fontSize="small" />
                }
            </Box>
        );
    }

    function getRecipientIcon(recipient: IFormRecipient) {
        return (

            <Box sx={{
                position: "relative",
                display: 'flex',
                marginRight: 1,
            }}
            >

            { 
                recipient.recipientType === RecipientTypeEnum.Email ?
                    <Email 
                        //fontSize="inherit" 
                    /> 
                :
                recipient.recipientType === RecipientTypeEnum.Text ?
                    <SmsOutlined  
                        //fontSize="inherit" 
                    /> :
                    <Phone
                        //fontSize="inherit" 
                    />
            }
           

            </Box>
        )
    }


    function renderRecipient() {

        const userRecipient = userRecipients[index];

        if (!userRecipient) {
            //console.log('no user recipient found', item.userID, index, userRecipients);
            // This can happen when creating adhoc users, where the user is not yet in the 
            // reference data. Once the data is refreshed, the user will be in the list.
            return null
        }

        return filteredRecipients.map((o, ndx) => {

            // need the 'real' index for the form data
            const itemIndex = userRecipient.recipients.findIndex(v => v.id === o.id);

            return (
                <Box
                    key={o.id}
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        flex: '1 1 auto'
                    }}>
                    <FormCheckbox
                        name={`userRecipients.${index}.recipients.${itemIndex}.selected`}
                        //label={`${RecipientTypeEnum[o.recipientType]}: ${o.to}`}
                        label={<Stack direction='row'>{getRecipientIcon(o)} {o.to}</Stack>}
                        sx={{ 
                            marginRight: 0,
                            marginTop: 0,
                        }}
                        typographyProps={{
                            sx: {
                                fontSize: '.95rem',
                            }
                        }}
                        onChange={(_event, checked) => onRecipientChanged(checked)}

                        />
                </Box>
            );});
    }

    return (
        <Card variant="outlined">
            <CardHeader
                sx={{
                    padding: 1
                }}
                title={getTitle()}
                //avatar={getAvatar()}
                //subheader={getSubheader()}
                //header={getTitle()}
                action={!hideActions ? <ActionMenu actionItems={actionItems} /> : undefined }
                slotProps={{
                    title: {
                        sx: {
                            fontSize: '1rem',
                        }
                    }
                }}
            >
            </CardHeader>
            <CardContent sx={{
                padding: (theme) => `0 ${theme.spacing(1)} ${theme.spacing(1)} ${theme.spacing(1)} !important`,
            }}>
                { renderRecipient() }
            </CardContent>
        </Card>
    );
}



// <Stack component='span' 
// direction='row' 
// sx={{
//     justifyContent: 'flex-end',
// }}>

// <Button size="small" onClick={() => {onExecuteAction(SetpointRecipientActions.Add, item)} /*onAction(UserMessageActionEnum.Delete, item)*/}>
//     {t('buttons.newRecipient')}
// </Button>


// <Button size="small" onClick={() => {onExecuteAction(SetpointRecipientActions.Edit, item)} /*onAction(UserMessageActionEnum.Delete, item)*/}>
//     {t('buttons.editRecipient')}
// </Button>

// </Stack>                    
